/**
 * Ce qu'une route de la fiche dit de son ouverture : l'élève, l'onglet, les gestes, le brief.
 *
 * La fiche s'ouvre toujours avec ses onglets (tranché par Wajih le 03/11). L'ancienne fiche
 * (`student-profil`) n'avait ses gestes qu'avec `withActions`, que toutes ses entrées vivantes passent :
 * Mes élèves, l'historique des lives, le live, Écoles. La seule qui ne le passait pas, l'entretien
 * hebdomadaire (`InterviewHeader.js`), est un écran que plus rien n'ouvre. Les autres routes poussaient
 * l'écran d'un geste — ses activités, ses rapports, ses contrôles, la conversation : elles ouvrent la
 * fiche sur leur onglet.
 */
import { type UITutorStudentTab } from "../../../types/tutorEleves"
import { type TutorStudentBriefParams } from "./useTutorStudentProfileData"
import { type TutorStudentId } from "./tutorStudentTabs"

/** Chaque route de la fiche et l'onglet qu'elle ouvre — la seule liste de ces routes ici. */
export const TAB_OF_ROUTE = {
    "student-profil": "overview",
    student: "activities",
    realizations: "activities",
    "live-reports": "reports",
    "school-assessments": "assessments",
    messenger: "messages",
} as const satisfies Record<string, UITutorStudentTab>

export type TutorStudentProfileRoute = keyof typeof TAB_OF_ROUTE

export type TutorStudentProfileOpening = {
    studentId: TutorStudentId | null
    tab: UITutorStudentTab
    briefParams: TutorStudentBriefParams
}

type Params = Record<string, unknown> | undefined

const idOf = (value: unknown): TutorStudentId | null =>
    typeof value === "number" || (typeof value === "string" && value !== "") ? value : null

export function readTutorStudentProfileRoute(
    route: TutorStudentProfileRoute,
    params: Params
): TutorStudentProfileOpening {
    return {
        studentId: idOf(params?.studentId),
        tab: TAB_OF_ROUTE[route],
        briefParams: {
            objectiveId: idOf(params?.objectiveId),
            liveOccurrenceId: idOf(params?.liveOccurrenceId),
            context: typeof params?.context === "string" ? params.context : "profile",
        },
    }
}
